const config = {
  name: 'app-crm',

  devPort: 3000,

  // sets the default theme from the /brands folder
  brand: 'sitebuilder',

  // set the environment, this will change the urls 'dev', 'prototype3'
  env: 'dev',

  // Logger for redux, defaults to false when in production
  reduxLogger: true,

  product: 'admin',
  loginProduct: 'crm',

  authentication_api: 'api_crm',

  getCurrentBrand (env) {
    if (env && env.brand) {
      return env.brand
    }

    return this.brand
  },

  getCustomAlias () {
    return {
      authentication_alias: 'modules/authentication'
    }
  },

  getCustomRuntimeConfig (runtimeConfig) {
    return Object.assign({}, runtimeConfig, {
      _fetchXsrfTokenHeaderName: 'X-CSRF-TOKEN',
      _fetchXsrfTokenSiteName: 'accounts_api',
      _fetchXsrfTokenEndpoint: '/v1.0/session/preauth',
      _fetchXsrfTokenDisabled: true
    })
  }
}

module.exports = config
